<template>
  <div style="position: relative;">
    <el-form ref="onlineOperationRecordFilter" :model="onlineOperationRecord" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="日期" prop="formFilter.opTime">
          <date-range class="filter-item" v-model="onlineOperationRecord.formFilter.opTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="名称" prop="formFilter.userName">
          <el-input class="filter-item" v-model="onlineOperationRecord.formFilter.userName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetOnlineOperationRecord">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshOnlineOperationRecord(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="onlineOperationRecord" :data="onlineOperationRecord.OnlineOperationRecord.impl.dataList" :size="defaultFormItemSize" @sort-change="onlineOperationRecord.OnlineOperationRecord.impl.onSortChange"
          header-cell-class-name="table-header-gray"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="onlineOperationRecord.OnlineOperationRecord.impl.getTableIndex" />
          <el-table-column label="用户名称" prop="userName">
          </el-table-column>
          <el-table-column label="时间点" prop="opTime">
<!--            <template slot-scope="scope">-->
<!--              <span>{{formatDateByStatsType(scope.row.opTime, 'second')}}</span>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column label="状态" prop="onlineType">
          </el-table-column>
          <el-table-column label="操作方式" prop="operationType">
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="onlineOperationRecord.OnlineOperationRecord.impl.totalCount"
            :current-page="onlineOperationRecord.OnlineOperationRecord.impl.currentPage"
            :page-size="onlineOperationRecord.OnlineOperationRecord.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="onlineOperationRecord.OnlineOperationRecord.impl.onCurrentPageChange"
            @size-change="onlineOperationRecord.OnlineOperationRecord.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { OnlineOperationRecordController, DictionaryController } from '@/api';

export default {
  name: 'onlineOperationRecord',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      onlineOperationRecord: {
        formFilter: {
          opTime: [],
          userName: undefined
        },
        formFilterCopy: {
          opTime: [],
          userName: undefined
        },
        OnlineOperationRecord: {
          impl: new TableWidget(this.loadOnlineOperationRecordWidgetData, this.loadOnlineOperationRecordVerify, true, false)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetOnlineOperationRecord () {
      this.$refs.onlineOperationRecordFilter.resetFields();
      this.refreshOnlineOperationRecord(true);
    },
    /**
     * 在线离线操作记录数据获取函数，返回Promise
     */
    loadOnlineOperationRecordWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        onlineOperationRecordDtoFilter: {
          userName: this.onlineOperationRecord.formFilterCopy.userName,
          opTimeStart: Array.isArray(this.onlineOperationRecord.formFilterCopy.opTime) ? this.onlineOperationRecord.formFilterCopy.opTime[0] : undefined,
          opTimeEnd: Array.isArray(this.onlineOperationRecord.formFilterCopy.opTime) ? this.onlineOperationRecord.formFilterCopy.opTime[1] : undefined
        },
        orderParam: [
          {
            fieldName: 'opTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        OnlineOperationRecordController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 在线离线操作记录数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadOnlineOperationRecordVerify () {
      this.onlineOperationRecord.formFilterCopy.userName = this.onlineOperationRecord.formFilter.userName;
      this.onlineOperationRecord.formFilterCopy.opTime = this.onlineOperationRecord.formFilter.opTime;
      return true;
    },
    /**
     * 更新在线操作记录
     */
    refreshOnlineOperationRecord (reloadData = false) {
      if (reloadData) {
        this.onlineOperationRecord.OnlineOperationRecord.impl.refreshTable(true, 1);
      } else {
        this.onlineOperationRecord.OnlineOperationRecord.impl.refreshTable();
      }
      if (!this.onlineOperationRecord.isInit) {
        // 初始化下拉数据
      }
      this.onlineOperationRecord.isInit = true;
    },
    onResume () {
      this.refreshOnlineOperationRecord();
    },
    initFormData () {
    },
    formInit () {
      this.refreshOnlineOperationRecord();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
